import { render, staticRenderFns } from "./ReleaseNotesDisplay.vue?vue&type=template&id=1f1cff3c&scoped=true"
import script from "./ReleaseNotesDisplay.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesDisplay.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesDisplay.vue?vue&type=style&index=0&id=1f1cff3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cff3c",
  null
  
)

export default component.exports